module.exports = __webpack_public_path__ + "img/link.ada5f744.svg";